module.exports = __webpack_public_path__ + "static/homepage-mobile-tmlewin-f0a0494b384d7178314e2bf9498e18ad.jpg";